import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFieldArray } from 'react-hook-form';

import { ContactsType } from 'common/types/clinics';
import { ContactsChildProps, ContactsFormValues } from '../models';

import AddAnother from '../AddAnother';
import { Input } from 'common/components';

import { Close, InputWrapper, InputContainer, WrapperContact } from '../styles';

const Website = ({
  errors,
  control,
  register,
  getValues,
  handleRemoveContact,
}: ContactsChildProps) => {
  const { t } = useTranslation();

  const prependKey = 'website';
  const { fields, append, remove } = useFieldArray<ContactsFormValues>({
    control,
    name: prependKey,
  });

  const handleAddAnother = () => {
    append({
      type: 'Website' as ContactsType,
      contactDetail: '',
    });
  };

  const removeContact = (index: number) => {
    const contacts = getValues(prependKey);
    if (contacts.length) {
      const contactWithId = contacts.find(
        (item, idx) => !!item.id && idx === index,
      );
      if (contactWithId) {
        handleRemoveContact(contactWithId.id);
      }
    }
    remove(index);
  };

  return (
    <WrapperContact>
      <label>{t('edit_contacts.website')}</label>
      {fields.map((field, index) => {
        const id = `${prependKey}.${index}.contactDetail`;
        const error = errors?.[prependKey]?.[index]?.contactDetail?.message;
        return (
          <InputWrapper key={field.id} last={index === fields.length - 1}>
            <InputContainer>
              <Input
                id={id}
                type="text"
                register={register}
                errorMessage={error}
                placeholder={t('edit_contacts.website') as string}
              />
            </InputContainer>
            {index !== 0 && <Close onClick={() => removeContact(index)} />}
          </InputWrapper>
        );
      })}

      <AddAnother title={t('add_another')} onClick={handleAddAnother} />
    </WrapperContact>
  );
};

export default Website;
